import { Done } from '@mui/icons-material';
import { Paper, Typography, useTheme } from '@mui/material';

const Pill = ({ children, sx, innerPill, pillStyles }) => {
  const theme = useTheme();
  return (
    <Paper
      elevation={0}
      sx={{
        px: innerPill ? 0 : 4,
        py: 2,
        borderRadius: '23px',
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        bgcolor: 'background.paper',
        boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
        fontWeight: 500,
        fontSize: '20px',
        ...pillStyles,
      }}
    >
      <Done sx={{ height: 20, width: 20 }} />
      <Typography sx={{ ...theme.typography.subtext, textAlign: 'left', ...sx }}>
        {children}
      </Typography>
    </Paper>
  );
};

export default Pill;
